export default __webpack_public_path__ + "static/media/640_dummy-2014-store01-de.a2d619a8.png";